import React from 'react';
import { FaExternalLinkAlt, FaLinkedin, FaCog, FaBrain, FaMicrophone, FaTrophy, FaRocket, FaFlask, FaPuzzlePiece } from 'react-icons/fa';
import './Portfolio.css';
import FintelDefenceShowcase from './FintelDefenceShowcase';

const Portfolio = ({ selectedServices = [] }) => {
  // Determine content based on selected services
  const isDigitalMarketing = selectedServices.includes('digital-marketing');
  const isWebDevelopment = selectedServices.includes('web-development');
  const isBothServices = isDigitalMarketing && isWebDevelopment;

  // Dynamic projects configuration
  const getProjects = () => {
    if (isBothServices) {
      return [
        {
          title: "Healthcare Web App – CRM & Client Portal",
          subtitle: <><FaCog className="project-icon" /> B2B Healthcare Solution</>,
          website: "www.healthcare.fliphats.com",
          description: "I built a comprehensive healthcare webapp with an integrated CRM, team assignment capabilities, and a dedicated client portal for seamless operations.",
          achievements: [
            "💻 Built a secure client portal in React",
            "📈 Developed an integrated CRM for patient management",
            "👥 Implemented a team assignment and workflow module",
            "🔒 Ensured HIPAA compliance for data security"
          ],
          techStack: ["React", "Node.js", "CRM Integration", "Client Portal", "Team Management"],
          category: "Custom Web Application",
          color: "52, 152, 219"
        },
        {
          title: "Valyoued.co.in – Brand + Custom Website",
          subtitle: <><FaBrain className="project-icon" /> Psychology & Wellness Startup</>,
          website: "www.valyoued.co.in",
          description: "Built the complete digital presence from scratch - custom website, brand strategy, and marketing campaigns that grew the startup to 27K+ monthly reach.",
          achievements: [
            "💻 Developed custom WordPress platform with advanced features",
            "🚀 Grew Instagram to 27K+ monthly views",
            "🎯 Designed high-converting content and lead funnels",
            "📊 Built automated webinar systems for lead generation"
          ],
          techStack: ["WordPress", "Custom PHP", "Instagram Marketing", "Lead Funnels", "Webinar Automation"],
          category: "Brand Building + Development",
          color: "78, 205, 196"
        },
        {
          title: "FintelDefence.com – B2B Platform + Marketing",
          subtitle: <><FaLinkedin className="project-icon" /> Fintech Cybersecurity</>,
          website: "www.finteldefence.com",
          description: "Created a professional B2B website with integrated lead capture and executed targeted social media campaigns that established market authority.",
          achievements: [
            "🏗️ Built responsive corporate website with CRM integration",
            "📈 Scaled LinkedIn presence and B2B engagement",
            "🎯 Generated qualified leads via targeted Meta Ads",
            "💼 Established thought leadership in fintech security"
          ],
          techStack: ["WordPress", "CRM Integration", "LinkedIn Strategy", "Meta Ads", "B2B Marketing"],
          category: "B2B Development + Marketing",
          color: "118, 75, 162"
        }
      ];
    } else if (isDigitalMarketing) {
      return [
        {
          title: "Valyoued.co.in – Explosive Brand Growth",
          subtitle: <><FaBrain className="project-icon" /> Psychology & Wellness Startup</>,
          website: "www.valyoued.co.in",
          description: "Architected a complete digital brand strategy and executed campaigns that transformed a concept into a thriving online community with massive reach.",
          achievements: [
            "🚀 Grew Instagram from 0 to 27K+ monthly views in 8 months",
            "💡 Built viral content strategy with 400% engagement boost",
            "🎯 Created automated webinar funnels generating consistent leads",
            "📊 Achieved 5X ROI on all marketing campaigns"
          ],
          techStack: ["Instagram Marketing", "Content Strategy", "Lead Funnels", "Community Management", "Analytics"],
          category: "Social Media Growth",
          color: "78, 205, 196"
        },
        {
          title: "FintelDefence.com – B2B Marketing Authority",
          subtitle: <><FaLinkedin className="project-icon" /> Fintech Cybersecurity</>,
          website: "www.finteldefence.com",
          description: "Executed strategic B2B social media campaigns that positioned a fintech startup as a thought leader and generated high-quality leads in a competitive niche.",
          achievements: [
            "📈 300% increase in LinkedIn engagement and followers",
            "🎯 Generated 50+ qualified B2B leads via targeted campaigns",
            "📊 Established brand authority with thought leadership content",
            "💼 Achieved 8X ROI on Meta Ads for B2B lead generation"
          ],
          techStack: ["LinkedIn Strategy", "Meta Ads", "B2B Content Marketing", "Lead Generation", "Analytics"],
          category: "B2B Marketing",
          color: "118, 75, 162"
        },
        {
          title: "Multiple Brand Campaigns – Viral Growth Specialist",
          subtitle: <><FaRocket className="project-icon" /> Cross-Industry Success</>,
          website: "15+ Successful Campaigns",
          description: "Managed and scaled social media campaigns across various industries, consistently delivering viral growth and measurable business results for clients.",
          achievements: [
            "📈 Averaged 5X ROI across all client campaigns",
            "🔥 Created viral content reaching 1M+ total views",
            "🎯 Optimized ad spend to reduce cost-per-lead by 60%",
            "💡 Built reusable frameworks for sustainable growth"
          ],
          techStack: ["Multi-Platform Ads", "Viral Content Creation", "Campaign Optimization", "ROI Analytics", "Growth Hacking"],
          category: "Performance Marketing",
          color: "255, 107, 107"
        }
      ];
    } else if (isWebDevelopment) {
      return [
        {
          title: "Healthcare Web App – CRM & Client Portal",
          subtitle: <><FaCog className="project-icon" /> B2B Healthcare Solution</>,
          website: "www.healthcare.fliphats.com",
          description: "I built a comprehensive healthcare webapp with an integrated CRM, team assignment capabilities, and a dedicated client portal for seamless operations.",
          achievements: [
            "💻 Built a secure client portal in React",
            "📈 Developed an integrated CRM for patient management",
            "👥 Implemented a team assignment and workflow module",
            "🔒 Ensured HIPAA compliance for data security"
          ],
          techStack: ["React", "Node.js", "CRM Integration", "Client Portal", "Team Management"],
          category: "Custom Web Application",
          color: "52, 152, 219"
        },
        {
          title: "Valyoued.co.in – WordPress Powerhouse",
          subtitle: <><FaBrain className="project-icon" /> Custom WordPress Development</>,
          website: "www.valyoued.co.in",
          description: "Built a high-performance WordPress website with custom functionality, advanced SEO optimization, and seamless user experience that handles high traffic.",
          achievements: [
            "🏗️ Developed custom WordPress theme with advanced features",
            "⚡ Achieved 95+ Google PageSpeed scores on mobile and desktop",
            "🔧 Built custom plugins for specialized business needs",
            "📱 Implemented full responsive design with mobile-first approach"
          ],
          techStack: ["WordPress", "Custom PHP", "Advanced CSS", "Performance Optimization", "SEO", "Mobile-First"],
          category: "WordPress Development",
          color: "78, 205, 196"
        },
        {
          title: "Multiple Shopify Stores – E-commerce Specialist",
          subtitle: <><FaCog className="project-icon" /> Shopify Development</>,
          website: "5+ Successful Stores",
          description: "Created and optimized multiple Shopify stores with custom themes, advanced functionality, and conversion-focused design that maximizes sales.",
          achievements: [
            "🛒 Built 5+ successful Shopify stores with custom features",
            "💰 Implemented conversion optimization strategies",
            "📊 Integrated advanced analytics and tracking systems",
            "⚡ Optimized for speed, SEO, and mobile performance"
          ],
          techStack: ["Shopify", "Liquid Templates", "Custom CSS/JS", "App Integration", "Payment Systems", "Analytics"],
          category: "E-commerce Development",
          color: "118, 75, 162"
        }
      ];
    }
    // Fallback to original projects
    return [
      {
        title: "Valyoued.co.in – Brand & Community Growth",
        subtitle: <><FaBrain className="project-icon" /> Psychology & Wellness Startup</>,
        website: "www.valyoued.co.in",
        description: "Architected a complete digital brand from a mere concept, creating a thriving online community and a powerful lead generation engine.",
        achievements: [
          "🚀 Grew Instagram to 27K+ monthly views",
          "💡 Built a full digital brand from scratch",
          "🎯 Designed and executed a high-converting content strategy",
          "🎤 Automated webinar funnels that generated consistent leads"
        ],
        techStack: ["Brand Strategy", "Instagram Marketing", "Content Creation", "Lead Funnels", "Community Management"],
        category: "Brand Building & Growth",
        color: "78, 205, 196"
      },
      {
        title: "FintelDefence.com – B2B Social Media Marketing",
        subtitle: <><FaLinkedin className="project-icon" /> Fintech Cybersecurity</>,
        website: "www.finteldefence.com",
        description: "Executed targeted B2B social media campaigns on LinkedIn and Instagram, establishing brand authority and driving qualified leads in a niche market.",
        achievements: [
          "📈 Scaled LinkedIn presence and engagement",
          "🎯 Generated qualified B2B leads via targeted ads",
          "📊 Established brand as a thought leader in fintech security",
          "💼 Managed and optimized Meta Ads for maximum ROI"
        ],
        techStack: ["B2B Marketing", "LinkedIn Strategy", "Meta Ads", "Content Marketing", "Lead Generation"],
        category: "Social Media Marketing",
        color: "118, 75, 162"
      },
      {
        title: "Digital Harish – Marketing Tech Lab",
        subtitle: <><FaCog className="project-icon" /> Where Marketing Meets Technology</>,
        website: "https://portfolioweb.fliphatmedia.com",
        description: "My personal brand and technology playground. Here, I build and test the marketing automation tools and websites that power my clients' success.",
        achievements: [
          "✅ Developed custom marketing automation tools",
          "✅ Manages hosting and tech for 30+ client websites",
          "✅ Provides high-level consulting on marketing tech stacks",
          "✅ Integrates development with marketing goals"
        ],
        techStack: ["React", "WordPress", "Marketing Automation", "SEO Tech", "API Integration"],
        category: "Marketing Technology",
        color: "102, 126, 234"
      }
    ];
  };

  // Dynamic client wins based on service selection
  const getClientWins = () => {
    if (isBothServices) {
      return [
        {
          number: "50+",
          description: "Websites built & optimized"
        },
        {
          number: "8X",
          description: "Average growth across all projects"
        },
        {
          number: "27K+",
          description: "Peak monthly social reach achieved"
        },
        {
          number: "100%",
          description: "Client satisfaction in 2024"
        }
      ];
    } else if (isDigitalMarketing) {
      return [
        {
          number: "5X",
          description: "Average ROI for marketing campaigns"
        },
        {
          number: "27K+",
          description: "Peak monthly social reach for a client"
        },
        {
          number: "15+",
          description: "Successful brand & marketing campaigns"
        },
        {
          number: "300%",
          description: "Best engagement increase achieved"
        }
      ];
    } else if (isWebDevelopment) {
      return [
        {
          number: "50+",
          description: "Websites successfully built"
        },
        {
          number: "95+",
          description: "Average Google PageSpeed score"
        },
        {
          number: "3 Years",
          description: "Full-stack development experience"
        },
        {
          number: "100%",
          description: "Project delivery success rate"
        }
      ];
    }
    // Fallback to original wins
    return [
      {
        number: "5X",
        description: "Average ROI for marketing clients"
      },
      {
        number: "27K+",
        description: "Peak monthly social reach for a client"
      },
      {
        number: "15+",
        description: "Successful brand & marketing campaigns"
      },
      {
        number: "100%",
        description: "Client satisfaction in 2024"
      }
    ];
  };

  const projects = getProjects();
  const clientWins = getClientWins();

  return (
    <section id="portfolio" className="portfolio-section section">
      <div className="container">
        <h2 className="section-title">
          <FaFlask className="section-icon" /> 
          {isBothServices ? 'Complete Digital Solutions' : isDigitalMarketing ? 'Marketing Success Stories' : isWebDevelopment ? 'Development Portfolio' : 'Portfolio Highlights'}
        </h2>
        
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div
              key={index}
              className="project-card"
              style={{
                '--accent-color-rgb': project.color,
                '--accent-color': `rgb(${project.color})`
              }}
            >
              <div className="project-header">
                <div className="project-category">{project.category}</div>
                <h3 className="project-title">{project.title}</h3>
                <p className="project-subtitle">{project.subtitle}</p>
                {project.website && (
                  <div className="project-website">
                    <FaExternalLinkAlt />
                    <span>{project.website}</span>
                  </div>
                )}
              </div>
              
              <div className="project-content">
                <p className="project-description">{project.description}</p>
                
                <div className="project-achievements">
                  {project.achievements.map((achievement, idx) => (
                    <div key={idx} className="achievement-item">
                      {achievement}
                    </div>
                  ))}
                </div>
                
                <div className="project-tech">
                  <h4>Tech Stack & Skills:</h4>
                  <div className="tech-tags">
                    {project.techStack.map((tech, idx) => (
                      <span key={idx} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Client Wins Section */}
        <div className="client-wins">
          <h3 className="wins-title"><FaTrophy className="section-icon" /> Client Love (aka Wins)</h3>
          <div className="wins-grid">
            {clientWins.map((win, index) => (
              <div key={index} className="win-item">
                <div className="win-number">{win.number}</div>
                <div className="win-description">{win.description}</div>
              </div>
            ))}
          </div>
          
          <div className="success-highlight">
            <div className="highlight-box">
              <h4><FaRocket className="section-icon" /> My Approach</h4>
              <p>
                I blend creative marketing strategy with the technical skills to execute flawlessly. 
                This means I don't just give you ideas—I build the systems, run the campaigns, and deliver the results that grow your business.
              </p>
            </div>
          </div>
        </div>

        {/* Performance Snapshots Section */}
        <div className="performance-snapshots">
          <h3 className="snapshots-title">Performance Snapshots</h3>
          <div className="snapshots-grid">
            <div className="snapshot-item">
              <img src="/images/performance-1.jpg" alt="Digital marketing campaign performance dashboard showing engagement metrics, reach statistics, and ROI analytics" loading="lazy" />
            </div>
            <div className="snapshot-item">
              <img src="/images/performance-2.jpg" alt="Social media growth analytics displaying follower increase, engagement rates, and conversion tracking" loading="lazy" />
            </div>
            <div className="snapshot-item">
              <img src="/images/performance-3.jpg" alt="Google Ads campaign results showing click-through rates, cost per acquisition, and return on ad spend" loading="lazy" />
            </div>
            <div className="snapshot-item">
              <img src="/images/performance-4.jpg" alt="Meta Ads performance snapshot with audience insights, reach metrics, and conversion optimization data" loading="lazy" />
            </div>
          </div>
        </div>

        {/* Creative Showcase Section */}
        <div className="creative-showcase">
          <h3 className="showcase-title">Creative Showcase</h3>
          <div className="showcase-grid">
            <div className="showcase-item">
              <img src="/images/creative/creative-1.png" alt="Creative social media post design featuring brand elements and engaging visual content for digital marketing campaign" loading="lazy" />
            </div>
            <div className="showcase-item">
              <img src="/images/creative/creative-2.png" alt="Professional brand identity design showcasing logo, color palette, and marketing materials for comprehensive brand strategy" loading="lazy" />
            </div>
            <div className="showcase-item">
              <img src="/images/creative/creative-3.jpg" alt="Dynamic social media content creation with compelling visuals and strategic messaging for audience engagement" loading="lazy" />
            </div>
            <div className="showcase-item">
              <img src="/images/creative/creative-4.png" alt="Creative advertising banner design optimized for Meta and Google Ads campaigns with strong call-to-action elements" loading="lazy" />
            </div>
            <div className="showcase-item">
              <img src="/images/creative/creative-5.png" alt="Brand storytelling visual content designed for viral social media marketing and audience growth strategies" loading="lazy" />
            </div>
            <div className="showcase-item">
              <img src="/images/creative/creative-6.png" alt="Professional marketing collateral design including brochures, flyers, and digital assets for brand consistency" loading="lazy" />
            </div>
            <div className="showcase-item full-width">
              <img src="/images/creative/creative-7.png" alt="Creative campaign artwork featuring modern design trends and strategic brand positioning for maximum market impact" loading="lazy" />
            </div>
          </div>
        </div>

        {/* UI Showcase Section */}
        <div className="ui-showcase">
          <h3 className="showcase-title">UI Showcase</h3>
          <div className="showcase-grid">
            <div className="showcase-item">
              <img src="/images/ui/ui-1.png" alt="Modern web interface design featuring responsive layout, clean typography, and intuitive user experience for e-commerce platform" loading="lazy" />
            </div>
            <div className="showcase-item">
              <img src="/images/ui/ui-2.png" alt="Professional dashboard UI design with data visualization, interactive elements, and user-friendly navigation for business applications" loading="lazy" />
            </div>
            <div className="showcase-item">
              <img src="/images/ui/ui-3.png" alt="Mobile-first responsive web design showcasing conversion-optimized landing page with clear call-to-action buttons" loading="lazy" />
            </div>
            <div className="showcase-item">
              <img src="/images/ui/ui-4.png" alt="Custom WordPress theme design featuring modern aesthetics, SEO optimization, and enhanced user engagement elements" loading="lazy" />
            </div>
          </div>
        </div>

        <FintelDefenceShowcase />

        {/* Speaking & Webinars */}
        <div className="speaking-section">
          <h3 className="speaking-title">My Secret Sauce: The Marketing Funnel</h3>
          <div className="speaking-content">
            <div className="speaking-item">
              <div className="speaking-icon"><FaFlask /></div>
              <div className="speaking-text">
                <h4>Top Funnel: Awareness & Authority</h4>
                <p>I build brand awareness through strategic content and establish you as a thought leader.</p>
              </div>
            </div>
            <div className="speaking-item">
              <div className="speaking-icon"><FaPuzzlePiece /></div>
              <div className="speaking-text">
                <h4>Mid Funnel: Engagement & Nurturing</h4>
                <p>I create engaging experiences that nurture leads and build community.</p>
              </div>
            </div>
            <div className="speaking-item">
              <div className="speaking-icon"><FaTrophy /></div>
              <div className="speaking-text">
                <h4>Bottom Funnel: Conversion & Automation</h4>
                <p>I design automated systems that convert leads into loyal customers.</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Portfolio;
